<template lang="html">
  <section class="hand" :class="{ unfocused }">
    <ol class="playing-card-list" :class="{ reverse }">
      <li v-for="card in hand.cards" :key="card.id" class="playing-card-item">
        <PlayingCard
          :suit="card.suit"
          :rank="card.rank"
          :showing-face="card.showingFace"
        />
      </li>
    </ol>

    <span v-if="!settings.hideCardTotals" class="hand-total">{{
      hand.cardTotal
    }}</span>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import { clone } from 'lodash';

import PlayingCard from '@/components/PlayingCard';

export default {
  name: 'Hand',

  components: {
    PlayingCard,
  },

  props: {
    hand: {
      type: Object,
      required: true,
    },

    unfocused: {
      type: Boolean,
      default: false,
    },

    reverse: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters(['settings']),
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/mixins/unstyled-list';
@import '@/styles/mixins/position-flex-center';

.hand {
  display: flex;
  justify-content: center;
  position: relative;

  &.unfocused {
    opacity: 0.4;
  }
}

.hand,
.hand-total {
  transition: opacity map-get($transition-speeds, 'fast') ease-out;
}

.playing-card-list {
  @include unstyled-list;

  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(10px, max-content));

  &.reverse {
    // HACK: Gives reverse direction when using `display: grid`.
    direction: rtl;
  }
}

.playing-card-item {
  display: flex;
  justify-content: center;
}

.playing-card {
  flex-shrink: 0;
}

.hand-total {
  @include position-flex-center;

  $size: 2em;

  font-size: 0.9em;
  font-weight: bold;
  position: absolute;
  right: -3em;
  width: $size;
  height: $size;
  background-color: map-get($colors, 'faded-background-1x');
  border-radius: 50%;
}

@media all and (min-width: map-get($breakpoints, 'phone')) {
  $card-spacing: 0.5rem;

  .playing-card-item {
    margin: $card-spacing;
  }

  .playing-card-list {
    margin: -$card-spacing 0;

    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: center;

    &.reverse {
      direction: ltr;
      flex-direction: row-reverse;
    }
  }
}
</style>
